import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useBusiness } from "../../../../Common/Hooks/useBusiness";
import { useBuyCredits } from "../../../../Common/Hooks/useBuyCredits";
import { ChatbotSubscription } from "./ChatbotSubscription";
import { CreditsOverview } from "./CreditsOverview";
import { CreditTransactionsHistory } from "./CreditTransactionsHistory";
import { SubscriptionContentWrapper } from "./Styles";

interface SubscriptionContentProps {
  onClose: () => void;
  isCreditHistoryOpen: boolean;
  onCreditHistoryOpenChange: (isOpen: boolean) => void;
}

/**
 * Everything the business has contracted, in independent blocks: credits and
 * DD plan first, the chatbot subscription below. The credit history replaces
 * them in place while it's open; whoever shows this decides when it is, so
 * it can retitle itself.
 */
export const SubscriptionContent = ({
  onClose,
  isCreditHistoryOpen,
  onCreditHistoryOpenChange,
}: SubscriptionContentProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { business } = useBusiness();
  const { buyCredits } = useBuyCredits();

  if (!business) {
    return (
      <SubscriptionContentWrapper>
        <div style={{ textAlign: "center", padding: "3rem" }}>
          <p>{t("pricing.subscriptionContent.loading")}</p>
        </div>
      </SubscriptionContentWrapper>
    );
  }

  return (
    <SubscriptionContentWrapper>
      {isCreditHistoryOpen && <CreditTransactionsHistory onBack={() => onCreditHistoryOpenChange(false)} />}

      {/* Hidden rather than unmounted, so going back doesn't ask Stripe again */}
      <div style={{ display: isCreditHistoryOpen ? "none" : "contents" }}>
        {business.credits && (
          <CreditsOverview
            credits={business.credits}
            onOpenHistory={() => onCreditHistoryOpenChange(true)}
            onSubscribe={() => {
              onClose();
              navigate("/due-diligence-plans");
            }}
            onBuyCredits={buyCredits}
            onChangePlan={() => {
              onClose();
              navigate("/due-diligence-plans");
            }}
          />
        )}
        <ChatbotSubscription onClose={onClose} />
      </div>
    </SubscriptionContentWrapper>
  );
};
